module.exports = __webpack_public_path__ + "img/20220623164237.78043a31.png";